<template>
    <div class="content">
        <!-- 头部组件 -->
        <donate-top :name=name :fundnum=fundnum :goodsnum=goodsnum></donate-top>
        <!-- 内容 -->
        <div class="mine_box">
            <div class=mine_box_search>
                <el-form :inline="true" :model="formInline">
                    <el-form-item label="物品名称">
                        <el-input v-model="formInline.goodsName"></el-input>
                    </el-form-item>
                    <el-form-item label="接收单位">
                        <el-input v-model="formInline.uname"></el-input>
                    </el-form-item>
                    <el-form-item label="总价">
                        <el-col :span="11">
                            <el-input v-model="formInline.minAmount" style="width: 100%;"></el-input>
                        </el-col>
                        <el-col class="line" :span="2">~</el-col>
                        <el-col :span="11">
                            <el-input v-model="formInline.maxAmount" style="width: 100%;"></el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="danger" @click="getTableData" style="width:120px">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="mine_box_dec">
                <el-table :data="tableData" style="width: 100%" border :cell-style="cellStyle">
                    <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
                    <el-table-column prop="goodsName" label="物品名称" align="center"></el-table-column>
                    <el-table-column prop="goodsNum" label="数量" width="80" align="center"></el-table-column>
                    <el-table-column prop="goodsUnit" label="单位" width="80" align="center"></el-table-column>
                    <el-table-column prop="money" label="总价/元" width="160" align="center"></el-table-column>
                    <el-table-column prop="outTime" label="出库时间" width="160" align="center"></el-table-column>
                    <el-table-column prop="donor" label="接收单位" align="center"></el-table-column>
                    <el-table-column prop="remark" label="备注" width="80" align="center"></el-table-column>
                </el-table>
                <!-- 分页 -->
                <div class="pag">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.pageNo"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DonateTop from '../../components/DonateTop.vue'
export default {
  components: { DonateTop },
    data(){
        return{
            name:'',
            fundnum:123456,
            goodsnum:456789,
            // 搜索绑定的数据对象
            formInline:{
                goodsName:'',
                uname:'',
                minAmount:'',
                maxAmount:'',
                // 当前页
                pageNo:1,
                // 多少条
                pageSize:20
            },
            // 总共多少条
            total:400,
            // 表单数据
            tableData:[] 
        }
    },
    created(){
        this.name=this.$route.query.donate_name
        this.getTableData()
        this.getDonateAmount()
        this.getGoodsAmount()
    },
    methods:{
        // 获取总金额
        async getDonateAmount(){
            const {data:res}=await this.$http.get('/donate/totalMoney?type=1')
            if(res.code==200){
                this.fundnum=res.data
            }
        },
        async getGoodsAmount(){
            const {data:res}=await this.$http.get('/donate/totalMoney?type=2')
            if(res.code==200){
                this.goodsnum=res.data
            }
        },
        // 获取表格数据
        async getTableData(){
            const {data:res}=await this.$http.get('/donate/goodsOut',{params:this.formInline})
            if(res.code==200){
                this.tableData=res.data.lists
                this.total=res.data.count
                console.log(this.tableData)
            }
        },
        // 一页显示多少条
        handleSizeChange(newSize){
            this.formInline.pageSize=newSize
            this.getTableData()
        },
        // 当前页变动触发的处理函数
        handleCurrentChange(newPage){
            this.formInline.pageNo=newPage
            this.getTableData()
        },
        // 改变单元格颜色
        cellStyle({row, column, rowIndex, columnIndex}){
            if(column.label==='总价/元'){
                return 'color:#df000f'
            }
        }
    }
}
</script>

<style lang="less" scoped>
.mine_box{
    width: 100%;
    .mine_box_search{
        height: 95px;
        padding: 25px 0;
        box-sizing: border-box;
        display: flex;
        justify-content: space-around;
    }
}
.line{
    text-align: center;
}
.el-button--danger{
    background-color: #d1322c;
}
.mine_box_dec{
    box-sizing: border-box;
    padding-bottom: 30px;
    .pag{
        text-align: center;
        margin-top: 30px;
    }
}
</style>